import { createContext, useContext, useEffect, useState, ReactNode } from 'react'

export type ThemeMode = 'light' | 'dark'
export type ThemeAccent = 'green' // Sabit green

interface ThemeContextType {
    mode: ThemeMode
    accent: ThemeAccent
    toggleMode: () => void
    setAccent: (accent: ThemeAccent) => void
}

const ThemeContext = createContext<ThemeContextType>({
    mode: 'light',
    accent: 'green',
    toggleMode: () => { },
    setAccent: () => { },
})

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
    const [mode, setMode] = useState<ThemeMode>(
        () => (localStorage.getItem('theme-mode') as ThemeMode) || 'light'
    )

    // Accent sabit green — localStorage'dan gelse de green kullan
    const accent: ThemeAccent = 'green'

    useEffect(() => {
        const html = document.documentElement
        html.setAttribute('data-theme-mode', mode)
        html.setAttribute('data-theme-accent', 'green')
        localStorage.setItem('theme-mode', mode)
        localStorage.setItem('theme-accent', 'green')
    }, [mode])

    const toggleMode = () => setMode(prev => prev === 'light' ? 'dark' : 'light')
    const setAccent = (_a: ThemeAccent) => { } // no-op

    return (
        <ThemeContext.Provider value={{ mode, accent, toggleMode, setAccent }}>
            {children}
        </ThemeContext.Provider>
    )
}

export const useTheme = () => useContext(ThemeContext)